/* ag-reviews-a11y (a11y Phase 2 batch 2b-reviews, 2026-10-23; workspace design-handoff/accessibility-remediation/2b-reviews-spec.md):
   Judge.me renders through app blocks the theme can't edit, so this names and fixes its controls after they render.
   - R1 review-photo links: named "Photo 1 of 2 from <reviewer>'s review (opens in a new tab)"; the image inside goes alt=""
     (Judge.me's alt is "User picture", and before the image loads the link has no name at all). Enter and a click both
     open the full photo in a new tab (probe 2026-10-23).
   - R2 star ratings inside a product-card link: no longer a separate button (Enter on it only opened the product, like the
     card link around it); read as "Rated 4.67 out of 5 from 6 reviews".
   - R3 the product page's star button: "Rated 5.00 out of 5 from 1 review. Go to reviews"; after Judge.me scrolls to the
     reviews, focus follows to the reviews heading.
   - R4 the histogram's "See all reviews" (shown after a filter) is a button. Judge.me already handles Enter on it.
   Judge.me sets the badge's role, tabindex and label again about two seconds after load, so a MutationObserver re-applies
   on those attributes as well as on new content (paging, sorting, filtering). Writes happen only when a value differs,
   so the observer settles. Mouse behaviour and the look are unchanged. */
(function () {
  'use strict';
  if (window.agReviewsA11y) return;
  window.agReviewsA11y = true;

  function set(el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); }
  function drop(el, name) { if (el.hasAttribute(name)) el.removeAttribute(name); }
  function count(n) { return n + (n === 1 ? ' review' : ' reviews'); }
  function rating(badge) {
    var score = badge.getAttribute('data-average-rating'), n = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    return score && !isNaN(n) ? 'Rated ' + score + ' out of 5 from ' + count(n) : null;
  }
  function shown(el) { return !!el.getClientRects().length && window.getComputedStyle(el).visibility !== 'hidden'; }

  function photos() {
    Array.prototype.forEach.call(document.querySelectorAll('a.jdgm-rev__pic-link'), function (a) {
      var rev = a.closest('.jdgm-rev');
      var all = rev ? rev.querySelectorAll('a.jdgm-rev__pic-link') : [a];
      var i = Array.prototype.indexOf.call(all, a) + 1;
      var who = rev && rev.querySelector('.jdgm-rev__author');
      who = who ? who.textContent.replace(/\s+/g, ' ').trim() : '';
      var label = 'Photo ' + i + ' of ' + all.length + (who ? ' from ' + who + "'s review" : ' from this review');
      if (a.target === '_blank') label += ' (opens in a new tab)';
      set(a, 'aria-label', label);
      var img = a.querySelector('img');
      if (img) set(img, 'alt', '');
    });
  }

  function badges() {
    Array.prototype.forEach.call(document.querySelectorAll('.jdgm-prev-badge__stars'), function (s) {
      var badge = s.closest('.jdgm-prev-badge');
      var label = badge && rating(badge);
      if (!label) return;
      if (s.closest('a')) {                       // R2: inside a product-card link
        drop(s, 'tabindex');
        set(s, 'role', 'img');
        set(s, 'aria-label', label);
      } else {                                    // R3: the product page's own button
        set(s, 'aria-label', label + '. Go to reviews');
      }
      var text = badge.querySelector('.jdgm-prev-badge__text');
      if (text) set(text, 'aria-hidden', 'true');   // the label already carries the count
    });
  }

  function clearFilter() {
    Array.prototype.forEach.call(document.querySelectorAll('.jdgm-histogram__clear-filter'), function (r) { set(r, 'role', 'button'); });
  }

  function apply() { photos(); badges(); clearFilter(); }

  // R3: after the product page's stars (or the count beside them) take the shopper to the reviews, focus goes there too.
  function toReviews(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var badge = e.target.closest && e.target.closest('.jdgm-prev-badge');
    if (!badge || badge.closest('a')) return;
    if (e.type === 'keydown' && e.key === ' ') {   // a button answers Space too; the click below runs this again
      e.preventDefault();
      if (e.target.click) e.target.click();
      return;
    }
    var w = document.getElementById('judgeme_product_reviews');
    if (!w) return;
    setTimeout(function () {
      var t = Array.prototype.filter.call(w.querySelectorAll('h1, h2, h3, .jdgm-rev-widg__title'), shown)[0] || w;
      if (!t.hasAttribute('tabindex')) {
        t.setAttribute('tabindex', '-1');
        t.addEventListener('blur', function () { t.removeAttribute('tabindex'); }, { once: true });
      }
      t.focus({ preventScroll: true });
    }, 700);
  }
  document.addEventListener('click', toReviews, true);
  document.addEventListener('keydown', toReviews, true);

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 150);
  }
  function start() {
    apply();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'role', 'tabindex', 'alt'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
